import styled from "styled-components";
import {colors} from "nxtconstants";

export const CALC_ACCENT = colors.chartAccent;
export const CALC_ACCENT_TEXT = colors.chartAccentText;
export const CALC_SWP_PHASE = colors.chartSwpPhase;
export const CALC_SUSTAIN_MARKER = colors.chartSustainMarker;

export const CalculatorSection = styled.section`
  padding: 4rem 0 6rem;
  font-family: "Lato";

  @media (max-width: 768px) {
    padding: 2rem 0 ;
  }
`;

export const PageTitle = styled.h1`
  font-size: 4.2rem;
  font-family: "DM Serif Display";
  font-weight: 400;
  color: ${colors.textBlack};
  width: 85%;
  max-width: 125rem;
  margin: 0 auto 3.2rem;
  letter-spacing: -0.02em;

  @media (max-width: 768px) {
    font-size: 2.8rem;
    margin: 0 auto 2rem;
    padding: 0;
  }
`;

export const MobileTabContainer = styled.div`
  display: none;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto 2rem;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  overflow: hidden;
  background: ${colors.white};

  @media (max-width: 768px) {
    display: flex;
  }
`;

export const MobileTabButton = styled.button`
  flex: 1;
  border: none;
  cursor: pointer;
  padding: 1.2rem 1.6rem;
  font-family: "Lato";
  font-size: 1.6rem;
  font-weight: 600;
  background: ${(props) => (props.active ? colors.secondary : colors.white)};
  color: ${(props) => (props.active ? colors.textBlack : colors.textGray)};
  transition: background 0.2s ease;

  &:not(:last-child) {
    border-right: 1px solid ${colors.lightGray};
  }
`;

export const CalculatorWrapper = styled.div`
  display: grid;
  grid-template-columns: 50rem minmax(0, 1fr);
  gap: 4rem 6rem;
  width: 85%;
  max-width: 125rem;
  margin: 0 auto;
  align-items: start;
  background-color: ${colors.white};
  border: 1px solid ${colors.lightGray};
  border-radius: 2rem;
  padding: 4rem;
  box-sizing: border-box;

  @media (max-width: 850px) {
    grid-template-columns: 1fr;
    gap: 0;
    width: 85%;
    padding: 2.4rem;
  }

  @media (max-width: 768px) {
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 0;
  }
`;

export const ControlPanel = styled.div`
  width: 100%;
  min-width: 0;

  @media (max-width: 768px) {
    display: ${(props) => (props.$hidden ? "none" : "block")};
    background-color: ${colors.white};
    padding: 2.4rem;
    width: 100%;
    margin: 0 auto;
    border: 1px solid ${colors.lightGray};
    border-radius: 1.2rem;
  }
`;

export const ResultsPanel = styled.div`
  min-width: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    display: ${(props) => (props.$hidden ? "none" : "block")};
    background-color: ${colors.white};
    padding: 2.4rem;
    width: 100%;
    margin: 0 auto;
    border: 1px solid ${colors.lightGray};
    border-radius: 1.2rem;
  }
`;

export const PhaseSection = styled.div`
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  margin-bottom: 2rem;
  box-shadow: 0 0.2rem 0.8rem rgba(0, 0, 0, 0.04);
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 767.98px) {
    box-shadow: none;
  }
`;

export const FormGrid = styled.div`
  padding: 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.4rem 3rem;
  align-items: end;

  @media (max-width: 767.98px) {
    padding: 0.75rem;
    gap: 1.4rem 1.6rem;
  }
`;

export const FormGridFullWidth = styled.div`
  grid-column: 1 / -1;
`;

export const PhaseTitle = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: ${colors.textBlack};
  font-family: "Lato";
  margin: 0;
`;

export const CompactField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  width: 100%;
  min-width: 0;
`;

export const CompactLabel = styled.span`
  font-size: 1.6rem;
  font-weight: 400;
  color: ${colors.textBlack};
  line-height: 1.4;
  font-family: "Lato";
  display: block;
`;

export const CompactValueBox = styled.div`
  width: 100%;
  min-height: 4.4rem;
  border: 1px solid #e5e7eb;
  border-radius: 1rem;
  background: ${colors.white};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.2rem;
  padding: 0.8rem 1.2rem;
  box-sizing: border-box;
  font-family: "Lato";
  font-size: 1.6rem;
  font-weight: 400;
  color: ${colors.textBlack};
  align-self: stretch;
`;

export const CompactInput = styled.input`
  border: none;
  background: transparent;
  width: 4rem;
  max-width: 8rem;
  text-align: center;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  color: inherit;
  outline: none;
  padding: 0;
`;

export const SummaryGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 2rem 3rem;
  background-color: ${colors.secondary};
  padding: 2.4rem 2.8rem;
  border-radius: 1.2rem;
  margin-bottom: 1.2rem;
  min-width: 0;

  @media (max-width: 1200px) {
    padding: 2rem;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const SustainSummary = styled.div`
  font-family: "Lato";
  font-size: 1.6rem;
  color: ${colors.textGray};
  margin-bottom: 2.4rem;

  strong {
    color: ${colors.textBlack};
    font-weight: 400;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileSummaryCard = styled.div`
  display: none;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  overflow: hidden;
  margin-bottom: 2rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileSummaryRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.4rem 2rem;
  font-size: 1.5rem;
  color: ${colors.textBlack};
  background: ${(props) => (props.$highlight ? colors.secondary : colors.white)};
  border-top: ${(props) => (props.$highlight ? "none" : `1px solid ${colors.lightGray}`)};
  font-weight: 400;

  span:first-child {
    flex-shrink: 0;
    max-width: 45%;
  }

  span:last-child {
    font-weight: 400;
    text-align: right;
    min-width: 0;
    word-break: break-word;
  }
`;

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
  flex: 1 1 0;
  min-width: max-content;
  max-width: 100%;
`;

export const SummaryLabel = styled.span`
  font-size: 1.8rem;
  color: ${colors.textGray};
  line-height: 1.3;
  white-space: nowrap;
`;

export const SummaryValue = styled.span`
  font-size: 2rem;
  font-weight: 400;
  color: ${colors.textBlack};
  line-height: 1.2;
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: 1.8rem;
  }
`;

export {ViewToggleButton, ViewToggleContainer} from "../ViewToggleStyles";

export const ChartHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1.2rem;
`;

export const SustainBadge = styled.div`
  font-family: "Lato";
  font-size: 1.3rem;
  color: ${colors.textGray};
  line-height: 1.4;

  strong {
    color: ${colors.textBlack};
    font-weight: 400;
  }
`;

export const ChartContainer = styled.div`
  width: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    margin: 0 -0.8rem;
    overflow-x: auto;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  max-height: 70rem;
  overflow-x: auto;
  overflow-y: auto;
  border: 1px solid ${colors.lightGray};
  border-radius: 1.2rem;
  -webkit-overflow-scrolling: touch;

  @media (max-width: 768px) {
    height: 36rem;
  }
`;

export const DataTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-family: "Lato";
  font-size: 1.3rem;

  th,
  td {
    padding: 1.2rem 1rem;
    text-align: right;
    border-bottom: 1px solid ${colors.lightGray};
    white-space: nowrap;
  }

  th:first-child,
  td:first-child {
    text-align: left;
  }

  th {
    color: ${colors.textGray};
    font-weight: 500;
    background: #fafafa;
    position: sticky;
    top: 0;
    z-index: 1;
    box-shadow: inset 0 -1px 0 ${colors.lightGray};
  }

  td {
    color: ${colors.textBlack};
  }
`;

export const LegendContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 2.4rem;
  padding-top: 1.5rem;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
`;

export const LegendSwatch = styled.div`
  width: 3rem;
  height: 0.5rem;
  background-color: ${(props) => props.color};
  border-radius: 0.6rem;

  @media (max-width: 768px) {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
  }
`;

export const LegendLabel = styled.span`
  margin-left: 1rem;
  font-size: 1.6rem;
  font-family: "Lato";
  color: ${colors.textGray};
`;

export const TooltipTotalRow = styled.p`
  color: #111827;
  margin: 0.8rem 0 0;
  font-weight: 600;
  display: flex;
  justify-content: space-between;
  gap: 1rem;
`;
